import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"

import { layoutStack, reverse as reverseStyle } from "./styles.module.scss"

function Stack({ children, reverse, className }) {
  return (
    <div
      className={classNames(
        layoutStack,
        {
          [reverseStyle]: reverse,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}

Stack.propTypes = {
  children: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
  className: PropTypes.string,
}

Stack.defaultProps = {
  reverse: false,
  className: undefined,
}

export default Stack
